module.exports = __webpack_public_path__ + "img/Personal-Growth@2x.38edc1ae.png";